module.exports = new __parcel__URL__("nceo-africa--dataset-cover.0b188ddc.jpg").toString();